/* unplugin-vue-components disabled */import { render } from "./toggle.vue?vue&type=template&id=0aacc0f8&scoped=true"
import script from "./toggle.vue?vue&type=script&lang=js"
export * from "./toggle.vue?vue&type=script&lang=js"

import "./toggle.vue?vue&type=style&index=0&id=0aacc0f8&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aacc0f8"],['__file',"src/controls/toggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0aacc0f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0aacc0f8', __exports__)) {
    api.reload('0aacc0f8', __exports__)
  }
  
  module.hot.accept("./toggle.vue?vue&type=template&id=0aacc0f8&scoped=true", () => {
    api.rerender('0aacc0f8', render)
  })

}


export default __exports__